import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "exportButton"]
  static values = {
    actionUrl: { type: String }
  }

  toggleAll(e) {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = e.target.checked
    })
    this.updateButtons()
  }

  updateButtons() {
    const selectedCount = this.checkboxTargets.filter(cb => cb.checked).length
    const anyChecked = selectedCount > 0

    this.exportButtonTarget.disabled = !anyChecked
    this.exportButtonTarget.classList.toggle("opacity-50", !anyChecked)
    this.exportButtonTarget.classList.toggle("cursor-not-allowed", !anyChecked)

    this.selectAllTarget.checked = selectedCount === this.checkboxTargets.length
    this.selectAllTarget.indeterminate = selectedCount > 0 && selectedCount < this.checkboxTargets.length
  }

  exportSelected() {
    const selectedIds = this.checkboxTargets
      .filter(cb => cb.checked)
      .map(cb => cb.value)

    if (selectedIds.length === 0) return

    const form = document.createElement('form')

    form.method = 'POST'
    form.action = this.actionUrlValue

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content
    const csrfInput = document.createElement('input')
    csrfInput.type = 'hidden'
    csrfInput.name = 'authenticity_token'
    csrfInput.value = csrfToken
    form.appendChild(csrfInput)

    selectedIds.forEach(id => {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'ids[]'
      input.value = id
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
    form.remove()
  }
}
